import React, { FC, useEffect, useRef, useState } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { QUESTION_LIST_VARIANTS } from "../../../../_store/constants"
import { StateType } from "../../../../_store/types"

import QuestionCard from "../QuestionCard/QuestionCard"

type DragContainerProps = {
  draggingCardClientRect: StateType["isDraggingData"]["cardClientRect"],
  dragXY: [x: number, y: number],
  isMobile?: boolean,
  isDraggingQuestionId: StateType["isDraggingData"]["questionId"],
  questions: StateType["questions"],
}

const DragContainerDIV = styled.div`
  position: absolute;
  z-index: 8;
  pointer-events: none;
`

const DragContainer: FC<DragContainerProps> = ({
  draggingCardClientRect,
  dragXY,
  isMobile,
  isDraggingQuestionId,
  questions,
}) => {
  if (!draggingCardClientRect || !isDraggingQuestionId) return null

  const [portalEl, setPortalEl] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const _portalEl = document.createElement('div')

    setPortalEl(_portalEl)
    document.body.append(_portalEl)
    document.body.style.overflow = "hidden"

    return () => {
      document.body.removeChild(_portalEl)
      setPortalEl(null)
      document.body.style.overflow = "auto"
    }
  }, [])

  return portalEl ? ReactDOM.createPortal(
    <DragContainerDIV
      style={{
        left: draggingCardClientRect?.x + window.scrollX || 0,
        top: draggingCardClientRect?.y + window.scrollY || 0,
        width: draggingCardClientRect.width,
        height: draggingCardClientRect.height,
        transform: `translate3d(${dragXY[0]}px, ${dragXY[1]}px, 0)`,
      }}
    >
      <QuestionCard
        index={0}
        isDragging
        isMobile={isMobile}
        variant={QUESTION_LIST_VARIANTS.INTERVIEW}
        {...questions[isDraggingQuestionId]}
      />
    </DragContainerDIV>
    , portalEl)
    : null
}

export default DragContainer
